// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const NotificationBarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-notificationbarcontainer" */ "./NotificationBarContainer")).then((bundle)=>{
        return {
            default: bundle.NotificationBarContainer
        };
    });
export const LazyNotificationBarContainer = /*#__PURE__*/ lazy(NotificationBarContainerLazyLoader);
